import * as React from 'react';
import dayjs from 'dayjs';
import { asyncActions } from '@docavenue/core';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { closestAvailabilitiesActions } from '@/src/actions';
import useIsPrescriber from '@/src/hooks/useIsPrescriber';

const useClosestAvailabilities = (card: CardHcd) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [closestAvailabilities, setClosestHasAvailabilities] = React.useState<
    any
  >();
  const [isLoadingAvailabilities, setIsLoadingAvailabilities] = React.useState(
    true,
  );
  const isPrescriber = useIsPrescriber();

  React.useEffect(() => {
    (async () => {
      if (!card?.settings?.clientDocavenue) return;
      setIsLoadingAvailabilities(true);
      const from = router.query.focus
        ? dayjs(router.query.focus as string).subtract(2, 'days')
        : dayjs();
      const data = await asyncActions(
        dispatch,
        closestAvailabilitiesActions.getActions(isPrescriber).getList({
          centerId: card?.center?.id || card?.center?.structureId,
          practitionerId: card?.professional?.practitionerId,
          from: from
            .add(1, 'minute')
            .startOf('minute')
            .toISOString(),
        }),
      );

      setClosestHasAvailabilities(data);
      setIsLoadingAvailabilities(false);
    })();
  }, [card]);

  return { closestAvailabilities, isLoading: isLoadingAvailabilities };
};

export default useClosestAvailabilities;
